<script lang="ts">
  import { onMount } from "svelte"
  import { Layout } from "../../components";
  import { downloadFile, getFile, buildUrl } from "../../services/endpoints"
  import { _ } from "svelte-i18n"
  import { Code } from "@gl/design-system"
  import type { File } from "../../services/models"
  import { StatusEnum } from "../../services/models"
  
  let file: File;
  export let uuid;
  let url: string = ""

  $: if(file) {
    console.log(file.uuid)
    url = buildUrl(`file/${file.uuid}/download`)
  }

  function download() {
    downloadFile(uuid).then((response) => {
        const href = URL.createObjectURL(response);

        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', uuid + '.mp4');
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(href);
    });
  }

  onMount(() => {
    getFile(uuid).then(f => file = f)
  })

</script>

<Layout selected="files">
  <h1>{$_("common.file")}</h1>
  {#if file}
  {#if file?.status?.status == StatusEnum.FINISHED}
  <button on:click={() => download()}>Download</button>
  <video
    src={url}
    controls
  />
  {/if}
  <Code>
    {JSON.stringify(file, null, 2)}
  </Code>
  {/if}
</Layout>